import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズの Item（品目台帳 / PRC Force）ロゴアイコン
 */
export function ProductLogoSmallItem({
  size = 20,
  color = '#00BE64',
  ...props
}: ProductLogoSmallProps) {
  return <svg width={size} height={size} viewBox="0 0 480 480" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M59.9971 160.878V337.421C59.9971 350.109 67.8656 361.466 79.7443 365.924L217.064 417.457C220.796 418.858 224.778 416.099 224.778 412.113V225.023C224.778 218.679 220.844 213.001 214.904 210.772L67.7108 155.533C63.9789 154.133 59.9971 156.892 59.9971 160.878Z" fill={color} />
      <path d="M420 160.878V337.421C420 350.109 412.131 361.466 400.252 365.924L262.933 417.457C259.201 418.858 255.219 416.099 255.219 412.113V225.023C255.219 218.679 259.153 213.001 265.092 210.772L412.286 155.533C416.018 154.133 420 156.892 420 160.878Z" fill={color} />
      <path d="M84.5132 119.949L229.3 65.6133C236.196 63.0254 243.797 63.0254 250.693 65.6133L395.48 119.949C400.417 121.801 400.417 128.784 395.48 130.637L245.345 186.98C241.897 188.274 238.096 188.274 234.648 186.98L84.5132 130.637C79.5763 128.784 79.5763 121.801 84.5132 119.949Z" fill={color} />
    </svg>;
}